import type { TRetryView } from '../helpers/models';

export const ACTION_TRIGGER = {
    ONCLICK: 'onClick',
    ONSELECT: 'onSelect',
    ONINPUTFINISHED: 'onInputFinished',
    ONSMSRETRYCLICK: 'onSmsRetryClick',
};

/** Шаги на которых доступен `retry` запроса при получении соответствующих статусов ошибок */
export const retryIdentificationStatuses = ['BAD_GATEWAY', 'GATEWAY_TIMEOUT'];
export const retryAuthenticationStatuses = [
    'BAD_GATEWAY',
    'GATEWAY_TIMEOUT',
    'VALIDATION_CODE_EXPIRED',
];

export const retryAuthenticationViews: TRetryView = {
    BAD_GATEWAY: 'confirmationSingOnlineError',
    VALIDATION_CODE_EXPIRED: 'confirmationCodeExpiredError',
    GATEWAY_TIMEOUT: 'confirmationSingOnlineError',
};

export const retryIdentificationViews: TRetryView = {
    BAD_GATEWAY: 'requestCodeSignOnlineError',
    GATEWAY_TIMEOUT: 'requestCodeSignOnlineError',
};
